import { get, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

import AsOfDate from '../AsOfDate'
import { NO_DATA_MESSAGE } from '../../utils/constants'
import ScrollingTable from '../Tables/ScrollingTable'

class Duration extends PureComponent {
  constructor(props) {
    super(props)

    const duration = get(props, 'data.duration')

    const asOfDate = duration && get(duration, '[0].calendar.date')
    const fundName = get(props, 'data.name') || 'Fund'

    const valueRenderer = (props) => (
      <span>
        {typeof props.value === 'number' ? props.value.toFixed(1) : '--'}
      </span>
    )

    const tableData = []
    const columns = [
      {
        Header: 'Duration',
        id: 'duration',
        accessor: 'name',
      },
      {
        Header: `${fundName} %`,
        id: 'fund',
        accessor: 'fund',
        Cell: valueRenderer,
      },
    ]

    if (duration && duration.length > 0) {
      // adds benchmark to columns

      if (duration[0]?.benchmarkIndex) {
        columns.push({
          Header: `${duration[0].benchmarkIndex.name} %`,
          id: 'benchmark-0',
          accessor: `benchmark-0`,
          Cell: valueRenderer,
        })
      }

      duration.forEach((item) => {
        const data = { name: item.name, fund: item.fundValue }
        if (item.benchmarkValue) {
          data[`benchmark-0`] = item.benchmarkValue
        }
        tableData.push(data)
      })
    }

    this.state = {
      columns,
      data: tableData,
      asOfDate,
    }
  }

  render() {
    const { presentation } = this.props
    const { columns, data, asOfDate } = this.state

    this.scrollingTableOptions = {
      stripedTable: true,
      presentation: presentation,
    }

    if (isEmpty(data)) {
      return <p>{NO_DATA_MESSAGE}</p>
    }

    return (
      <>
        <AsOfDate date={asOfDate} />
        <ScrollingTable
          data={data}
          columns={columns}
          options={this.scrollingTableOptions}
        />
      </>
    )
  }
}

Duration.propTypes = {
  data: PropTypes.shape({
    duration: PropTypes.array,
    name: PropTypes.string,
  }),
  presentation: PropTypes.object,
}

export default Duration
